import { SwipeRecord } from "../../data/models.interface"
import useQuery from "../useQuery"
import useSessionStorage from "../useSessionStorage"
import useSort, { SortDirection } from "../useSort"

export interface SwipeRecordsQuery {
	data: SwipeRecordsOutput | undefined
	loading: boolean
	error: string | undefined
	dateMinFilter: string
	setDateMinFilter: (value: string) => void
	dateMaxFilter: string
	setDateMaxFilter: (value: string) => void
	entityFilter: string
	setEntityFilter: (value: string) => void
	keycardFilter: string
	setKeycardFilter: (value: string) => void
	doorFitler: string
	setDoorFilter: (value: string) => void
	typeFilter: string
	setTypeFilter: (value: string) => void
	statusFilter: string
	setStatusFilter: (value: string) => void
	sortBy: (property: string, direction?: SortDirection) => void
}
export const useGetSwipeRecordsQuery = (page: string): SwipeRecordsQuery => {
	const [dateMinFilter, setDateMinFilter] = useSessionStorage(page + "-dateMin", "")
	const [dateMaxFilter, setDateMaxFilter] = useSessionStorage(page + "-dateMax", "")
	const [entityFilter, setEntityFilter] = useSessionStorage(page + "-entity", "")
	const [keycardFilter, setKeycardFilter] = useSessionStorage(page + "-keycard", "")
	const [doorFitler, setDoorFilter] = useSessionStorage(page + "-door", "")
	const [typeFilter, setTypeFilter] = useSessionStorage(page + "-type", "")
	const [statusFilter, setStatusFilter] = useSessionStorage(page + "-status", "")
	const { sortProperty, sortDirection, sortBy } = useSort("date", SortDirection.DESC)
	//
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/swipe-records`
	let filterUrl = ""
	if (dateMinFilter) filterUrl += `&dateMin=${dateMinFilter}`
	if (dateMaxFilter) filterUrl += `&dateMax=${dateMaxFilter}`
	if (entityFilter) filterUrl += `&entity=${entityFilter}`
	if (keycardFilter) filterUrl += `&keycard=${keycardFilter}`
	if (doorFitler) filterUrl += `&door=${doorFitler}`
	if (typeFilter) filterUrl += `&type=${typeFilter}`
	if (statusFilter) filterUrl += `&status=${statusFilter}`
	filterUrl += `&sort=${sortProperty}`
	filterUrl += `&sort-direction=${sortDirection}`
	filterUrl = filterUrl.replace("&", "?")
	const query = useQuery<void, SwipeRecordsOutput>(url + filterUrl)
	return {
		...query,
		dateMinFilter,
		setDateMinFilter,
		dateMaxFilter,
		setDateMaxFilter,
		entityFilter,
		setEntityFilter,
		keycardFilter,
		setKeycardFilter,
		doorFitler,
		setDoorFilter,
		typeFilter,
		setTypeFilter,
		statusFilter,
		setStatusFilter,
		sortBy,
	}
}
interface SwipeRecordsOutput {
	swipeRecords: SwipeRecord[]
}
